module.exports = __webpack_public_path__ + "static/media/linkedin.828fc6a8.svg";